<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="page_title"></page-header-title>

        <v-spacer></v-spacer>

        <action-button type="cancel" @click="$emit('return_modal_cancel_form')" v-if="modal == true" />
        <action-button type="back" @click="$router.go(-1)" v-if="modal != true" />
        <action-button type="save" @click="save" :disabled="$hasExtraModule('equipment') != 'active'" />

        <action-button
          type="delete"
          @click="del(equipmentmodel.id)"
          v-if="equipmentmodel.id && $can('equipment-access') && modal != true"
          :disabled="$hasExtraModule('equipment') != 'active'"
        />
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="equipmentmodel.name"
                  v-model="equipmentmodel.name"
                  v-validate="'max:50'"
                  :label="$t('equipmentmodels.name')"
                  :error-messages="errors.collect('equipmentmodel.name')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-combobox
                  name="equipmentmodel.equipment_manufacturer_id"
                  v-model="selectedEquipmentManufacturer"
                  class="required-field"
                  v-validate="'required'"
                  item-text="name"
                  item-value="id"
                  :items="equipmentmanufacturers"
                  :label="$t('equipmentmanufacturers.stitle')"
                  :error-messages="errors.collect('equipmentmodel.equipment_manufacturer_id')"
                  v-on:keyup.enter="equipmentManufacturerOnEnter"
                  @blur="equipmentManufacturerOnBlur"
                  clearable
                >
                  <template v-slot:no-data>
                    <v-list-item>
                      <span class="subheading">{{ $t("global.no_data_create") }}</span>
                    </v-list-item>
                  </template></v-combobox
                >
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-select
                  name="equipmentmodel.status"
                  v-model="equipmentmodel.status"
                  class="required-field"
                  v-validate="'required'"
                  item-text="text"
                  item-value="key"
                  :items="$dd_task_status()"
                  :label="$t('tasks.status')"
                  :error-messages="errors.collect('equipmentmodel.status')"
                  clearable
                ></v-select>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "EquipmentModelForm",

  props: ["id", "modal"],

  data() {
    return {
      page_title: "",
      predata: {},
      equipmentmodel: {},
      selectedEquipmentManufacturer: null,
      equipmentmanufacturers: [],
      dictionary: {
        attributes: {
          "equipmentmodel.name": this.$t("equipmentmodels.name"),
          "equipmentmodel.equipment_manufacturer_id": this.$t("equipmentmanufacturers.stitle"),
          "equipmentmodel.status": this.$t("equipmentmodels.status")
        }
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    if (this.$hasExtraModule("equipment") == "active") {
      this.$validator.validateAll().then(() => {
        this.$leaveFormConfirmation(next, this.equipmentmodel, this.predata, this.save, this.isFormValid)
      })
    } else {
      next()
    }
  },

  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    }
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  created() {
    if (!this.id) {
      this.page_title = this.$t("equipmentmodels.new_title")
      this.equipmentmodel = {
        status: this.$getDefaultDropdown(this.$dd_task_status())
      }
      this.selectedEquipmentManufacturer = null

      this.predata = JSON.parse(JSON.stringify(this.equipmentmodel))
      this.ddlist()
    } else {
      axios
        .get(this.API_URL + "equipment-model/" + this.id)
        .then((res) => {
          this.equipmentmodel = res.data.data
          this.predata = JSON.parse(JSON.stringify(this.equipmentmodel))
          this.ddlist()

          this.page_title = this.$t("equipmentmodels.edit_title", {
            name: this.equipmentmodel.name
          })
        })
        .catch((err) => console.log(err))
    }
  },

  methods: {
    ddlist() {
      axios.get(this.API_URL + "equipment-manufacturers?show_all=true").then((res) => {
        this.equipmentmanufacturers = res.data.data

        if (this.id) {
          this.selectedEquipmentManufacturer = this.equipmentmanufacturers.find(
            (i) => i.id == this.equipmentmodel.equipment_manufacturer_id
          )
        }
      })
    },
    save() {
      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            let vm = this
            let user = this.$store.getters["auth/user"]

            if (!this.equipmentmodel.id) {
              // Create
              axios
                .post(this.API_URL + "equipment-model", {
                  name: this.equipmentmodel.name,
                  equipment_manufacturer_id: this.selectedEquipmentManufacturer.id || null,
                  status: this.equipmentmodel.status,
                  created_by: user.id
                })
                .then((res) => {
                  if (typeof res.data.errors !== "undefined") {
                  } else {
                    if (res.data.data.id) {
                      vm.equipmentmodel = res.data.data
                      vm.predata = JSON.parse(JSON.stringify(vm.equipmentmodel))

                      vm.$awn.success(vm.$t("global.create_success"))

                      if (vm.modal) {
                        vm.$emit("return_modal_form", {
                          module: "equipmentmodels",
                          mode: "add",
                          data: res.data.data
                        })
                      } else {
                        vm.page_title = this.$t("equipmentmodels.edit_title", {
                          name: vm.equipmentmodel.name
                        })
                        vm.$router.replace(this.BACKEND_URL + `/equipment-models/edit/${vm.equipmentmodel.id}`).catch(() => {})
                      }
                    }
                  }
                })
                .catch((err) => console.log(err))
            } else {
              // Update
              axios
                .put(this.API_URL + "equipment-model", {
                  id: this.equipmentmodel.id,
                  name: this.equipmentmodel.name,
                  equipment_manufacturer_id: this.selectedEquipmentManufacturer.id || null,
                  status: this.equipmentmodel.status
                })
                .then((res) => {
                  vm.equipmentmodel = res.data.data
                  vm.predata = JSON.parse(JSON.stringify(vm.equipmentmodel))

                  vm.$awn.success(vm.$t("global.update_success"))

                  if (vm.modal) {
                    vm.$emit("return_modal_form", {
                      module: "equipmentmodels",
                      mode: "edit",
                      data: res.data.data
                    })
                  }
                })
                .catch((err) => console.log(err))
            }
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },
    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "equipment-model/" + id)
            .then((res) => {
              vm.$router.push(this.BACKEND_URL + "/equipment-models")
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },
    equipmentManufacturerOnBlur(e) {
      let val = this.selectedEquipmentManufacturer

      if (typeof val === "string" && val) {
        this.selectedEquipmentManufacturer = null
      }
    },
    equipmentManufacturerOnEnter(e) {
      let val = this.selectedEquipmentManufacturer

      if (e.keyCode == 13) {
        if (typeof val === "string" && val) {
          let user = this.$store.getters["auth/user"]
          let obj = {
            name: val,
            status: 1,
            created_by: user.id
          }
          let exist = this.equipmentmanufacturers.find((i) => i.name == val)

          if (!exist) {
            // Add new equipment manufacturer
            axios
              .post(this.API_URL + "equipment-manufacturer", obj)
              .then((res) => {
                this.equipmentmanufacturers.push(res.data.data)
                this.selectedEquipmentManufacturer = res.data.data
                this.$awn.success(this.$t("global.create_success"))
              })
              .catch((error) => {
                this.$handleServerSideError(error)
              })
          } else {
            this.selectedEquipmentManufacturer = exist
          }
        }
      }
    }
  }
}
</script>

<style scoped></style>
